import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import {getPriceText} from "../../../../util/commonFunctions";
import React from "react";
import {Price} from "../../../../types/cart";

interface Args{
    totalPrice: Price;
    totalDiscountAmount: number;
    selectedCouponIdx: number | null;
    codeDiscountAmount: number;
    isGirdField?: boolean
}
export function OrderSummaryField(
    {totalPrice, totalDiscountAmount, selectedCouponIdx, codeDiscountAmount, isGirdField}: Args) {
    return (
        <div className={`${style.orderedAmountInfo} ${isGirdField && style.grid}`}>
            <h3 className={style.sectionTitle}>주문정보</h3>
            <div className={style.amountDetail}>
                <ul className={style.amountList}>
                    <li className={style.amountItem}>
                        <span>총 상품 금액</span>
                        <span>{getPriceText(totalPrice.regularAmount)}원</span>
                    </li>
                    {totalDiscountAmount > 0 && (
                        <li className={`${style.amountItem} ${style.accent}`}>
                            <span>할인금액</span>
                            <span>-{getPriceText(totalDiscountAmount)}원</span>
                        </li>
                    )}
                    {totalPrice.productDiscountAmount > 0 && (
                        <li className={style.amountItem}>
                            <span>ㄴ 상품 할인</span>
                            <span>-{getPriceText(totalPrice.productDiscountAmountShown)}원</span>
                        </li>
                    )}
                    {selectedCouponIdx ? (
                        <li className={style.amountItem}>
                            <span>ㄴ 쿠폰 할인</span>
                            <span>-{getPriceText(totalPrice.couponDiscountAmountShown)}원</span>
                        </li>
                    ) : (
                        <></>
                    )}
                    {codeDiscountAmount !== 0 ? (
                        <li className={style.amountItem}>
                            <span>ㄴ 코드 할인</span>
                            <span>-{getPriceText(codeDiscountAmount)}원</span>
                        </li>
                    ) : (
                        <></>
                    )}
                </ul>
                <div className={style.totalAmount}>
                    <span>총 결제금액</span>
                    <span>{getPriceText(totalPrice.actualAmountShown)}원</span>
                </div>
            </div>
        </div>
    );
}